import React from 'react';

const LiveSupport2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.66406 4.58422C1.66406 3.20318 2.78362 2.08362 4.16467 2.08362H12.5C13.8811 2.08362 15.0006 3.20318 15.0006 4.58422V9.58543C15.0006 10.9665 13.8811 12.086 12.5 12.086H9.16587L4.9982 14.5866V12.086H4.16467C2.78362 12.086 1.66406 10.9665 1.66406 9.58543V4.58422Z",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.49999 12.9197V12.9197C7.49999 14.3007 8.61955 15.4203 10.0006 15.4203H11.6677L15.0018 17.9209V15.4203H15.8353C17.2164 15.4203 18.3359 14.3007 18.3359 12.9197V9.58556C18.3359 8.20452 17.2164 7.08496 15.8353 7.08496H15.0018",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "4.16406",
      y: "6.25134",
      width: "1.66707",
      height: "1.66707",
      rx: "0.416767",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "7.5",
      y: "6.25134",
      width: "1.66707",
      height: "1.66707",
      rx: "0.416767",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "10.8359",
      y: "6.25134",
      width: "1.66707",
      height: "1.66707",
      rx: "0.416767",
      fill: "white"
    }
  )
);

export { LiveSupport2 };
//# sourceMappingURL=LiveSupport2.js.map
